var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmOrg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2226_1642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7983 9.99999C25.3349 7.7312 24.0985 5.69354 22.3002 4.23479C20.5018 2.77603 18.2529 1.9866 15.9373 2.00124C13.6218 2.01587 11.383 2.83366 9.60324 4.31503C7.82345 5.7964 6.61292 7.84953 6.17827 10.124C4.33353 10.4535 2.6791 11.462 1.54098 12.9507C0.402859 14.4394 -0.136412 16.3004 0.0294295 18.167C0.195271 20.0336 1.0542 21.7704 2.43696 23.0351C3.81972 24.2999 5.62604 25.0009 7.49997 25H7.99997V23H7.49997C6.07435 23.0009 4.70414 22.4479 3.6786 21.4576C2.65306 20.4673 2.05243 19.1173 2.00351 17.6925C1.95458 16.2677 2.4612 14.8797 3.4164 13.8214C4.3716 12.7631 5.70064 12.1173 7.12297 12.0205L7.95947 11.9634L8.04947 11.1299C8.25175 9.26937 9.10044 7.53881 10.4476 6.23976C11.7948 4.94072 13.5551 4.15557 15.4218 4.02112C17.2884 3.88667 19.1431 4.41146 20.6626 5.50402C22.182 6.59659 23.2699 8.18766 23.7368 9.99999H25.7983Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12H18C17.4698 12.0006 16.9614 12.2115 16.5865 12.5865C16.2115 12.9614 16.0006 13.4698 16 14V18H12C11.4698 18.0006 10.9614 18.2115 10.5865 18.5865C10.2115 18.9614 10.0006 19.4698 10 20V30H30V14C29.9994 13.4698 29.7885 12.9614 29.4135 12.5865C29.0386 12.2115 28.5302 12.0006 28 12ZM12 28V20H16V28H12ZM28 28H18V14H28V28Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16H20V20H22V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 16H24V20H26V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 22H20V26H22V22Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 22H24V26H26V22Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2226_1642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmOrg);
export default __webpack_public_path__ + "static/media/crm-org.4e109be0e3daeb5fd12421ebda07c556.svg";
export { ForwardRef as ReactComponent };